export default "__VITE_ASSET__8468ef79__"